module.exports = __webpack_public_path__ + "static/media/tree-decorated.0b94a4d3.svg";